import {
  Button,
  CircularProgress,
  Paper,
  Snackbar,
  SnackbarContent,
  TextField,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { Form, Formik } from "formik";
import { useState } from "react";
import * as Yup from "yup";
import LogoSvg from "src/images/logo.svg";
import { login as apiLogin } from "src/services/login";
import {
  HeaderLogoImage,
  StyledContainer,
  StyledLogoContainer,
} from "./styles";
import { useAuth } from "src/contexts/AuthContext";

export default function Login() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const { login } = useAuth();
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState<{ message: string; type: "success" | "error" } | null>(null);

  const validationSchema = Yup.object({
    cpf: Yup.string().required("CPF é obrigatório"),
    password: Yup.string().required("Senha é obrigatória"),
  });

  const handleLogin = async (values: { cpf: string; password: string }) => {
    try {
      setLoading(true);
      const response = await apiLogin(values);
      if (response?.status === 200 && response?.data?.access_token) {
        login(response.data.access_token);
      } else {
        setToast({ message: "Usuário ou senha inválidos. ❌", type: "error" });
      }
    } catch (error: any) {
      setToast({ message: "Usuário ou senha inválidos. ❌", type: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <StyledContainer>
        <Paper
          elevation={6}
          sx={{
            padding: theme.spacing(isSmallScreen ? 3 : 4),
            width: isSmallScreen ? "100%" : "400px",
            maxWidth: "400px",
            borderRadius: 2,
          }}
        >
          <StyledLogoContainer>
            <HeaderLogoImage src={LogoSvg} alt="Logo Uniservice" />
          </StyledLogoContainer>

          <Formik
            initialValues={{ cpf: "", password: "" }}
            validationSchema={validationSchema}
            onSubmit={handleLogin}
          >
            {({ values, errors, touched, handleChange, handleBlur }) => (
              <Form>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="cpf"
                  label="CPF"
                  name="cpf"
                  autoComplete="cpf"
                  autoFocus
                  variant="outlined"
                  value={values.cpf}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.cpf && Boolean(errors.cpf)}
                  helperText={touched.cpf && errors.cpf}
                />

                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label="Senha"
                  type="password"
                  id="password"
                  autoComplete="current-password"
                  variant="outlined"
                  value={values.password}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.password && Boolean(errors.password)}
                  helperText={touched.password && errors.password}
                />

                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  disabled={loading}
                  sx={{ mt: 3, mb: 2 }}
                >
                  {loading ? <CircularProgress size={24} color="inherit" /> : "Acessar"}
                </Button>

              </Form>
            )}
          </Formik>
        </Paper>
      </StyledContainer>
      <Snackbar
        open={Boolean(toast)}
        autoHideDuration={3000}
        onClose={() => setToast(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <SnackbarContent
          message={toast?.message}
          sx={{
            backgroundColor:
              "#fff",
            color:
              toast?.type === "success" ? "#4caf50" : "#f44336",
            fontWeight: 700,
            borderRadius: 1,
          }}
        />
      </Snackbar>
    </>
  );
}
